import { globalLogin } from 'APIs/identity';
import Spinner from 'Components/Spinner/Spinner';
import { ReactComponent as LogoIcon } from 'assets/svg/april-logo.svg';
import { ReactComponent as EmailIcon } from 'assets/svg/email.svg';
import { ReactComponent as PasswordIcon } from 'assets/svg/password.svg';
import React, { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { clearZendeskWidget } from 'utils/zendesk';

import { Btn, ErrorBar, SpinnerWrapper, Wrapper } from './styles';

const GlobalLogin = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    document.title = 'Sign in - April';
    clearZendeskWidget();
  }, []);

  const handleChangePassword = (e: ChangeEvent<HTMLInputElement>): void => {
    setPassword(e.target.value);
  };

  const handleChangeEmail = (e: ChangeEvent<HTMLInputElement>): void => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const loginResp = await globalLogin({
        email,
        password,
      });
      if (loginResp.success) {
        window.location.href = loginResp.redirectUrl;
      } else {
        throw Error(`Login failed: ${loginResp.error?.message ?? 'Unknown error'}`);
      }
    } catch (error) {
      setErrorMessage(error?.message || 'Login failed!');
      setIsLoading(false);
    }
  };

  return (
    <Wrapper>
      <header className="header">
        <nav className="nav">
          <div className="logo-wrapper">
            <LogoIcon className="logo" />
          </div>
        </nav>
      </header>
      <div className="content">
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-header">
            <h3 className="form-title">Log in to your account</h3>
            {errorMessage.length > 0 && <ErrorBar dangerouslySetInnerHTML={{ __html: errorMessage }} />}
          </div>
          <div className="input-wrapper">
            <label className="label" htmlFor="email">
              <div className="icon-wrapper">
                <EmailIcon className="email-icon" />
              </div>
              <input
                className="input"
                type="email"
                autoFocus
                id="email"
                name="email"
                value={email}
                placeholder="EMAIL ADDRESS"
                onChange={handleChangeEmail}
                autoComplete="username"
              />
            </label>
          </div>
          <div className="input-wrapper">
            <label className="label" htmlFor="password">
              <div className="icon-wrapper">
                <PasswordIcon className="password-icon" />
              </div>
              <input
                className="input"
                type="password"
                id="password"
                name="password"
                value={password}
                placeholder="PASSWORD"
                onChange={handleChangePassword}
                autoComplete="current-password"
              />
            </label>
          </div>
          <div className="input-submit">
            <small className="small">
              <NavLink className="forget-password" to={`/forget-password`}>
                Forgot your password?
              </NavLink>
              <Btn type="submit" disabled={email.length === 0 || password.length === 0 || isLoading}>
                Log in
                {isLoading && (
                  <SpinnerWrapper>
                    <Spinner />
                  </SpinnerWrapper>
                )}
              </Btn>
            </small>
          </div>
        </form>
      </div>
    </Wrapper>
  );
};

export default GlobalLogin;
